import React from 'react';
import styled from 'styled-components';

const outlineColors = {
  icon: '148,0,255',
  temperature: '0,255,222',
  danger: '255,128,0'
};

const transparentWhite = 'rgba(255,255,255,0.65)';
const ItemMenuContainer = styled.div`
  height: 64px;
  width: 64px;
  pointer-events: all;
  border-radius: 4px;
  outline-style: ${props => (props.inherited ? 'double' : 'solid')};
  // outline-style: ${props => outlineColors[props.type]};
  outline-width: 4px;
  outline-offset: -1px;
  outline-color: rgba(${props => outlineColors[props.type]}, 0.65);
  transform: translate(
    ${props => (props.type === 'temperature' ? 0 : -50)}%,
    -50%
  );

  background-color: ${props =>
    props.inherited ? transparentWhite : 'transparent'};

  transition: outline-color 0.25s ease-in-out;
  transition: background-color 0.25s ease-in-out;

  &:hover {
    outline-color: rgba(${props => outlineColors[props.type]}, 1);
    background-color: rgb(255, 255, 255, 0.25);
    transition: background-color 0.25s ease-in-out;
    transition: outline-color 0.25s ease-in-out;
  }

  &:focus-within {
    outline-color: rgba(${props => outlineColors[props.type]}, 1);
    background-color: rgb(255, 255, 255, 0);
    background-color: rgba(${props => outlineColors[props.type]}, 0.25);
    transition: outline-color 0.25s ease-in-out;
    transition: background-color 0.125s ease-in-out;
  }
`;

const Input = styled.input`
  width: 100%;
  height: 100%;
  color: white;
  pointer-events: auto;
  text-align: center;
  background-color: transparent;
  -webkit-text-stroke-color: red;
  -webkit-text-stroke-width: 1px;
  border: 0;
  font-weight: bold;
  font-size: 225%;
  outline: none;

  //&:focus::selection {
  //  width: 64px;
  //
  //  height: 64px;
  //  background-color: red;
  //}
`;

const ItemMenuRBB = ({
  item,
  data: {key, value},
  callback,
  disabled,
  inherited
}) => {
  const [itemValue, setItemValue] = React.useState(value);

  const publicChange = () => {
    callback(item, {[key]: {value: itemValue}});
    setItemValue(itemValue);
  };

  const privateChange = e => {
    const value = e.target.value ? e.target.value.replace(',', '.') : '';
    setItemValue(value);
  };

  React.useEffect(() => {
    setItemValue(value.toString());
  }, [value]);

  return (
    <ItemMenuContainer type={item.type} inherited={item.inherited}>
      <div
        style={{
          // backgroundColor: 'red',
          display: 'flex',
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
        <Input
          value={itemValue}
          onFocus={e => e.target.select()}
          disabled={item.inherited}
          onChange={privateChange}
          onBlur={publicChange}
          onKeyPress={e => {
            if (e.key === 'Enter' || e.keyCode === 13) {
              publicChange();
            }
          }}
        />
      </div>
    </ItemMenuContainer>
  );
};
export default ItemMenuRBB;
